module.exports = __webpack_public_path__ + "img/undraw_blank_canvas.b0b283cb.svg";